import SERVER_URL from '../Global';
import { errorInterceptor } from '../util/axiosConfig';
const axios = require('axios').default;

export default class ArticleService {
    constructor(token) {
        this.api_token = token;
        this.client = null;
        this.api_url = SERVER_URL;
    }
    init = () => {
        let headers = {
            Accept: "application/json",
        };
        if (this.api_token) {
            headers.Authorization = `Bearer ${this.api_token}`;
        }
        this.client = axios.create({ baseURL: this.api_url, timeout: 0, headers: headers });
        this.client.interceptors.response.use(errorInterceptor);

        return this.client;
    };

    getArticleList = (data) => {
        return this.init().post('/api/article/list', data)
    }

    deleteArticle = (id) => {
        return this.init().delete('api/article/' + id);
    }

    deleteArticleMassive = (id) => {
        return this.init().post('api/article/MassiveDelete', id);
    }

    addArticle = (data) => {
        return this.init().post('api/article/', data);
    }

    getArticle = (id) => {
        const params = localStorage.getItem("params");
        return this.init().post(
            'api/article/' + id, 
            params ? params : {},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }
    

    updateArticle = (data) => {
        return this.init().put('api/article', data);
    }

    getCategories = () =>{
        return this.init().get('api/category/list');
    }

    massiveUpdateStatus = (data) => {
        return this.init().post('api/article/UpdateStatus', data)
    }

    massiveImport = (formdata, magazineId) => {
        return this.init().post('api/article/MassiveImport', formdata, {
            params: { magazineId }
        });
    }
}



// WEBPACK FOOTER //
// ./src/Services/articleService.js